<template>
  <div>
    <el-card v-loading="loading" class="box-card">
      <div slot="header" class="box-header">
        <div class="box-header__title">Создание новости</div>
        <!--        <div class="box-header__counter">-->
        <!--          <span class="box-header__counter_accent">{{ countUser }}</span> пользователей найдено по этому фильтру-->
        <!--        </div>-->
      </div>

      <div class="description">
        Пожалуйста, внимательно проверьте и заполните информацию перед тем как переходить дальше
      </div>
      <!--      list-type="picture-card"-->

      <el-upload
        action="https://jsonplaceholder.typicode.com/posts/"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :limit="1"
        drag
        class="upload">
          <i class="el-icon-plus"></i>
          <div class="el-upload__text"><em>Добавить</em> картинку к новости</div>
          <div class="el-upload__tip" slot="tip">jpg/png файл размером 500kb</div>
      </el-upload>

      <el-form ref="main-form" :rules="mainFormRules" :model="push" v-if="push" class="main-form">
        <el-form-item label="Заголовок" prop="push_title">
          <el-input name="title" autosize placeholder="Введите заголовок..." v-model="push.push_title"></el-input>
        </el-form-item>
        <el-form-item label="Текст совета дня" prop="push_body">
          <el-input
            size="medium"
            v-model="push.push_body"
            maxlength="255"
            name="title"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 8}"
            placeholder="Введите описание..."
          ></el-input>
        </el-form-item>
        <el-form-item label="Дата совета дня" prop="push_date">
          <el-date-picker
            size="medium"
            v-model="push.date"
            type="date"
            value-format="yyyy-MM-dd"
            format="dd.MM.yyyy"
            class="dialog__date"
            placeholder="Укажите дату..."
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <div class="buttons">
          <el-button
            :loading="loadMainForm"
            slot="reference"
            class="buttons__btn"
            type="primary"
          >Далее
          </el-button>
        </div>
      </el-form>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'cpanel.news.new',
  data () {
    return {
      pushId: this.id,
      genderList: [],
      genderLoading: false,
      loading: false,
      push: {
        questions_id: [],
        gender: [],
        screen_id: ''
      },
      questionnaireList: {},
      mobileScreensList: {},
      countUser: 0,
      loadMainForm: false,
      dialogImageUrl: '',
      dialogVisible: false,
      error: null,
      mainFormRules: {
        push_title: [
          {
            required: true,
            message: 'Проверьте это поле',
            trigger: 'blur'
          }
        ],
        push_body: [
          {
            required: true,
            message: 'Проверьте это поле',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.loadLogic()
  },
  props: {
    id: {}
  },
  watch: {},
  computed: {},
  components: {},
  methods: {
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    loadLogic () {
      if (this.pushId) this.getPush()
    },
    getPush () {
      this.$api.push
        .view(this.pushId)
        .then((response) => {
          this.push = { ...response.data, ...this.push }
          this.push.questions_id = []
          this.push.screen_id = response.data.screen.id

          if (response.data.questionnaire) {
            const options = response.data.questionnaire.questions
            this.push.questionnaire_list_id = response.data.questionnaire.id
            this.push.questions_id = this.fun(options)
          }

          this.$nextTick(() => {
            this.sendForm('countUser')
          })
        })
        .catch((response) => {
          console.log(response)
          this.$notify.error({
            title: 'Ошибка загрузки модели',
            message: response.data.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    sendForm (method, test) {
      let validation = false

      this.$refs['main-form'].validate((valid, data) => {
        validation = valid
      })
      if (!validation) return document.querySelector('#main-block').scroll(0, 0)

      let payLoad = { ...this.push, ...{ questions_id: [...new Set(this.push.questions_id.flat(Infinity))] } }

      if (method === 'send') {
        if (test) {
          payLoad = {
            params: {
              test: true
            }
          }
        }
        if (!this.pushId) {
          return this.$notify.warning({
            title: 'Ошибка',
            message: 'Сохраните шаблон перед отправкой'
          })
        }
      }

      this.loading = true
      this.$api.push[method](payLoad, this.pushId)
        .then((response) => {
          let message = 'Успешно отправлено'
          if (method === 'countUser') {
            this.countUser = response.data.count
            message = `Найдено пользователей: <b>${response.data.count}</b>`
          }
          if (method === 'create') {
            message = 'Фильтр создан'
            this.pushId = response.data.id
          }

          this.$notify.success({
            dangerouslyUseHTMLString: true,
            title: 'Успешно',
            message
          })
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка запроса',
            message: response.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
// todo вынести это, сделать подключаемым
.append /deep/ {
  .el-input__suffix-inner div {
    padding-right: 8px;
  }
}

.box-card {
  max-width: 960px;
  margin: 10px auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.description {
  margin: 4px 0 24px 0;
  font-size: 15px;
  color: #909399;
}

.box-header {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 16px;

  &__title {
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    color: #303133;
  }

  &__counter {
    font-size: 15px;
    color: #909399;

    &_accent {
      font-weight: bold;
      color: #5AC9AD;
      font-size: 16px;
    }
  }

}

.buttons {
  margin-top: 24px;
  padding-top: 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  &__btn {
    width: 100%;
  }
}

.gender-list {
  display: flex;
  margin: 10px 0;
  width: 100%;
}

.upload {
  /deep/ {
    .el-upload-dragger {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 12px;

      background-color: #fbfdff;
      border: 1px dashed #5AC9AD;
      border-radius: 6px;
      box-sizing: border-box;
      width: 240px;
      height: 160px;
      cursor: pointer;
      line-height: 1;
      vertical-align: top;
    }
    .el-icon-plus {
      color: #5AC9AD;
      font-size: 39px;
    }
    .title {
      width: 150px;

      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: #5AC9AD;

    }
  }
}
</style>
